import type { UISelectOption } from './nodeDefs.js';

export type RuntimeValuePortType = 'float' | 'bool' | 'string' | 'vec2' | 'vec3' | 'vec4';

export const RUNTIME_VALUE_TYPE_OPTIONS: readonly UISelectOption[] = [
  { value: 'bool', label: 'Boolean' },
  { value: 'number', label: 'Number' },
  { value: 'string', label: 'String' },
  { value: 'vec2', label: 'Vector 2' },
  { value: 'vec3', label: 'Vector 3' },
  { value: 'vec4', label: 'Vector 4' },
];

/** Canonical documents call scalar numbers `number`; graph ports call the
 * same scalar representation `float`. Unknown metadata safely falls back to
 * a scalar port until validation reports the document error. */
export function runtimeValuePortType(value: unknown): RuntimeValuePortType {
  switch (value) {
    case 'bool':
    case 'string':
    case 'vec2':
    case 'vec3':
    case 'vec4':
      return value;
    default:
      return 'float';
  }
}
